import { render } from "./TermsContent.vue?vue&type=template&id=9074d8e4&scoped=true"
import script from "./TermsContent.vue?vue&type=script&lang=js"
export * from "./TermsContent.vue?vue&type=script&lang=js"

import "./TermsContent.vue?vue&type=style&index=0&id=9074d8e4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9074d8e4"]])

export default __exports__